module.exports = __webpack_public_path__ + "static/media/end-booking.6781104c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/video-thumbnails/end-booking.png
// module id = 2174
// module chunks = 0